import { useFlyOutProductsBasedOnSelectedCloud } from '../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { isEmpty } from 'lodash'
import { useCurrentCloudProvider } from '@labrav/common'
import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { getProducts } from '../../modules/productsListing/action'
import type { Product } from '../../modules/productsListing/types'
import { useDispatch, useSelector } from '../../store'
import { MarketplaceIcon } from '../MarketplaceIcon/MarketplaceIcon'
import { ShortenedName } from '../../common/components/ShortenedName/ShortenedName'
import { useStyles } from './CloudAndProductNameTitle.styles'
import {
  isSubscriptionsPath,
  resolveCloudAndProductTitleProduct,
} from './helpers'

export type CloudAndProductNameTitleProps = {
  selectedProduct?: Product
}

export const CloudAndProductNameTitle = ({
  selectedProduct,
}: CloudAndProductNameTitleProps) => {
  const { classes } = useStyles({})
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const cloudMarketplace = useCurrentCloudProvider()
  const { accountId: routeAccountId } = useParams<{
    cloud: string
    accountId: string
  }>()
  const partnerId = useSelector<string>(
    state => state.AccountData.user.partnerData?.partnerId || ''
  )
  const { productId, secureKey } = useParams<{
    productId: string
    secureKey?: string
  }>()
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const product = resolveCloudAndProductTitleProduct(
    selectedProduct,
    products,
    productId
  )
  const shouldNotShowName = isSubscriptionsPath(pathname)
  useEffect(() => {
    if (!isEmpty(partnerId) && isEmpty(product) && !secureKey) {
      dispatch(getProducts(routeAccountId || '', cloudMarketplace))
    }
  }, [
    partnerId,
    product.productId,
    secureKey,
    routeAccountId,
    cloudMarketplace,
    dispatch,
  ])
  return !isEmpty(product) ? (
    <div
      className={classes.productNameContainer}
      data-testid="product-name-container"
    >
      <MarketplaceIcon
        classes={classes}
        cloudMarketplace={product.cloudMarketplace}
      />
      {!shouldNotShowName && (
        <div className={classes.sellerProductName}>
          <ShortenedName name={product.productName} />
        </div>
      )}
    </div>
  ) : (
    <div data-testid="empty-cloud-product-name"></div>
  )
}
